// Puerto del dominio (repository abstracto) para la consulta de riesgos consultables.
import { Observable } from 'rxjs';
import { ConsultableRisksInput, ConsultableRisksResult } from '../../interfaces/consultable-risks/consultable-risks.interface';

export abstract class ConsultableRisksRepository {
  abstract check(input: ConsultableRisksInput): Observable<ConsultableRisksResult>;
}
